<template>
    <div class="bnr">
        <div v-if="loading" class="loading"></div>
        <div class="container">
            <div class="content">
                <div v-swiper:mySwiper="swiperOptions">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="stock in stocks">
                            <img :src="axios.defaults.baseImageURL + stock.banner">
                        </div>
                    </div>
                    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['pStocks'],
        data () {
            return {
                stocks: null,
                loading: false,
                swiperOptions: {
                    speed: 700,
                    autoplay: {
                        delay: 4000,
                    },
                    loop: true,
                    // navigation: {
                    //     nextEl: '.swiper-button-next',
                    //     prevEl: '.swiper-button-prev'
                    // }
                }
            }
        },
        mounted() {
            if (this.pStocks){
                this.stocks = this.pStocks
            }else {
                this.loading = true
                this.axios
                    .get(this.axios.defaults.baseURL + 'stocks')
                    .then(response => {
                        this.stocks = response.data.stocks;
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/Banner.vue